import { FormGroup } from '@angular/forms';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-validar-obrigatorio[form][campo]',
  template: `
  <ng-container
    *ngIf="form.controls[campo].hasError('required') &&
    (form.controls[campo].dirty ||
    form.controls[campo].touched)
  ">
   {{ nome ? 'O campo ' + nome + ' é obrigatório' : 'Esse campo é obrigatório' }}
  </ng-container>`
})
export class ValidarObrigatorioComponent {

  @Input() campo: string;
  @Input() nome: string;
  @Input() form: FormGroup;

}
